// src/views/Base/components/NavBar/NavBar.tsx

import React from 'react';
import { FaBars } from 'react-icons/fa';
import './NavBar.scss';
import ColorModeToggle from './components/ColorModeToggle/ColorModeToggle';
import HeaderProfile from './components/HeaderProfile/HeaderProfile';
import SessionInfo from './components/SessionInfo/SessionInfo';
import { LocalSession } from '../../../../types/LocalSession';
import StaffTips from './components/StaffTips';

interface NavBarProps {
  isSidebarOpen?: boolean;
  setIsSidebarOpen?: (open: boolean) => void;
  lastSession?: LocalSession | null;
  setLastSession?: (session: LocalSession | null) => void;
}

// Re-export for backwards compatibility
export type { LocalSession };

const NavBar: React.FC<NavBarProps> = ({
  isSidebarOpen,
  setIsSidebarOpen,
  lastSession,
  setLastSession
}) => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  return (
    <nav
      className="mp-navbar flex items-center h-[52px] sticky top-0 z-[100] px-4 gap-2.5"
      style={{
        backgroundColor: 'var(--card-color)',
        borderBottom: '1px solid var(--border-color)',
      }}
    >
      {/* LEFT: Hamburger + Color Toggle */}
      <div className="flex items-center gap-2.5 shrink-0">
        <button
          className="navbar-hamburger items-center justify-center w-[34px] h-[34px] rounded-lg border text-sm cursor-pointer transition-all duration-150 hover:border-orange-400/30 active:scale-95"
          style={{
            borderColor: 'var(--border-color)',
            color: 'var(--text-color)',
            backgroundColor: 'var(--card-color)',
          }}
          onClick={() => setIsSidebarOpen && setIsSidebarOpen(!isSidebarOpen)}
        >
          <FaBars />
        </button>
        <div className="color-toggle-wrapper items-center">
          <ColorModeToggle />
        </div>
      </div>

      {/* CENTER: Session Info */}
      <div className="flex-1 flex justify-center min-w-0">
        {lastSession !== undefined && setLastSession !== undefined && (
          <SessionInfo session={lastSession} setSession={setLastSession} />
        )}
      </div>

      {/* RIGHT: Profile */}
      <div className="flex items-center shrink-0 gap-2.5">
        <StaffTips localId={user.local_id} userId={user.user_id} />
        <HeaderProfile />
      </div>
    </nav>
  );
};

export default NavBar;
